import { FaLaptopCode, FaShieldAlt, FaBolt, FaMobileAlt } from "react-icons/fa";
import wordpressQualitiesJson from "../../data/wordpressQualities3.json";

export default function Section8() {
  const wordpressQualitiesData = wordpressQualitiesJson;

  // Cycle through icons for each quality
  const icons = [FaLaptopCode, FaShieldAlt, FaBolt, FaMobileAlt];

  return (
    <div className="Section8 py-[60px] md:py-[100px] bg-[#f9f9f9]">
      {/* Heading */}
      <div className="text-center mb-16 max-w-4xl mx-auto">
        <h2 className="text-[28px] md:text-[36px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
          Why Having a <span className="text-[#DA2128]">WordPress Website</span> for Your Business is a Must
        </h2>
        <p className="mt-6 text-[#555] text-[16px] md:text-[18px] max-w-[600px] mx-auto">
          In today’s digital world, having a website is a must for any business. It acts as your 24/7 online storefront, helping you:
        </p>
      </div>

      {/* Grid with Icons */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-12 md:gap-16 w-[90%] md:w-[85%] mx-auto">
        {wordpressQualitiesData.map((item, index) => {
          const IconComponent = icons[index % icons.length]; // select icon
          return (
            <div
              key={index}
              className="flex flex-col items-center text-center p-6 rounded-2xl bg-white shadow-md"
            >
              {/* Icon */}
              <div className="mb-4">
                <IconComponent className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
              </div>

              {/* Title */}
              <h3 className="text-[18px] md:text-[20px] font-semibold text-[#151515] mb-2">
                {item.title}
              </h3>

              {/* Description */}
              <p className="text-[14px] md:text-[15px] leading-[22px] text-[#555]">
                {item.text}
              </p>
            </div>
          );
        })}
      </div>

      {/* Bottom Text */}
      <div className="text-center mt-12 w-[90%] md:w-[61%] mx-auto">
        <p className="text-[#555] text-[16px] md:text-[18px] leading-[22px]">
          If you already have a website, it’s crucial to maintain it. Regular updates, security patches, and performance checks are necessary to ensure your website stays secure, performs well, and continues to attract customers.
        </p>
      </div>
    </div>
  );
}
